import { z } from 'zod';
import { makeEvent } from './EventBase';
import { AttendedInstitution, LanguageTest, StudentPersonalDetails } from '@/api';

export const StudentProfileUpdated = makeEvent(
    'StudentProfileUpdated',
    z.object({
        id: z.number(),
        personal_details: StudentPersonalDetails.nullable(),
        attended_institutions: z.array(AttendedInstitution).nullable(),
        language_tests: z.array(LanguageTest).nullable(),
    }),
);

export type StudentProfileUpdated = (typeof StudentProfileUpdated)['schema']['_output'];
